const { forceArray } = require('../helpers')

const sportEventConvert = sportEvent => {
  const type = sportEvent.type

  let sportId = null
  let tournamentRound = null
  let tournament = null
  let category = null
  let venue = null

  if (sportEvent[type].tournament) {
    tournamentRound = sportEvent[type].tournamentRound
    tournament = sportEvent[type].tournament
    venue = sportEvent[type].venue
  }

  if (sportEvent[type].category) {
    category = sportEvent[type].category
    sportId = sportEvent[type].category.sport_id
  }

  const result = {
    id: sportEvent.id,
    type: sportEvent.type,
    seType: sportEvent.se_type || sportEvent.seType,
    external_id: sportEvent.external_id,
    liveodds: sportEvent.liveodds,
    status: sportEvent.status !== undefined && sportEvent.status !== null ? sportEvent.status : null,
    scheduled: sportEvent.scheduled,
    sport_id: sportId === null ? null : sportId,
    category_id: category && category.id,
    tournament_id: tournament === null ? null : tournament.id,
    tournament_round: tournamentRound || null,
    season_id: sportEvent.season ? sportEvent.season.id : null,
    name: sportEvent.name || null,
    venue: venue
      ? {
          name: venue.name,
          city: venue.city_name,
          capacity: venue.capacity,
          country_code: venue.country_code,
          map_coordinates: venue.map_coordinates
        }
      : null,
    markets: [],
    activeMarketsCount: sportEvent.activeMarketsCount
  }

  if (type === 'match') {
    const matchInfo = sportEvent.match

    result.match_status = matchInfo.status
    result.coverage_info = matchInfo.coverage_info
    result.match_stats = matchInfo.stats

    if (result.match_stats && result.match_stats.period_scores) {
      result.match_stats.period_scores = forceArray(result.match_stats.period_scores)
    }
  }

  const competitors = []

  if (sportEvent.competitors) {
    sportEvent.competitors.forEach(competitor => {
      const result = {
        id: competitor.id,
        name: competitor.name,
        qualifier: competitor.qualifier || null
      }

      if (competitor.players) {
        result.players = competitor.players
      }

      competitors.push(result)
    })
  }

  result.competitors = competitors

  sportEvent.markets &&
    sportEvent.markets.forEach(market => {
      if (!market) {
        return
      }

      result.markets.push({
        id: market.id,
        status: market.status,
        specifiers: market.specifiers,
        name: market.name,
        outcomes: market.outcomes
      })
    })

  return result
}

module.exports = { sportEventConvert }
